import createIcon from '../../createIcon';

/**
 * @component @name DeleteSweep
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgMTZIMTlWMThIMTVWMTZaTTE1IDhIMjJWMTBIMTVWOFpNMTUgMTJIMjFWMTRIMTVWMTJaTTMgMThDMyAxOS4xIDMuOSAyMCA1IDIwSDExQzEyLjEgMjAgMTMgMTkuMSAxMyAxOFY4SDNWMThaTTE0IDVIMTFMMTAgNEg2TDUgNUgyVjdIMTRWNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DeleteSweep = createIcon('DeleteSweep', [
  [
    'path',
    {
      d: 'M15 16H19V18H15V16ZM15 8H22V10H15V8ZM15 12H21V14H15V12ZM3 18C3 19.1 3.9 20 5 20H11C12.1 20 13 19.1 13 18V8H3V18ZM14 5H11L10 4H6L5 5H2V7H14V5Z',
      key: 'zbukce',
    },
  ],
]);

export default DeleteSweep;
